<template>
  <div>

    <b-row class="my-2">

      <b-form-input
        v-model="filters.search"
        placeholder="Buscar por nombres, apellidos o cedula"
        type="text"
        class="col-5 mx-1"
      />

      <v-select
        v-model="filters.tipoAuxiliar"
        :options="tipoAuxiliarOpts"
        placeholder="Tipo Auxiliar"
        class="col-3"
        label="text"
        :reduce="option => option.value"
      />

      <b-col
        cols="3"
        class="d-flex align-items-center justify-content-start"
      >
        <b-button variant="primary" @click="onSearchAux">
          <font-awesome-icon icon="magnifying-glass" style="color: white" />
          <span style="color: white"> buscar</span>
        </b-button>
      </b-col>

    </b-row>

    <b-overlay>
      <b-card class="principal">

        <div class="d-flex justify-content-between mb-1 mx-1">
          <div class="d-flex text-success align-items-center">
            <i class="fa-solid fa-filter"/>
            <!-- <span class="mx-1" v-html="getFiltrosAplicados"></span> -->
          </div>
          <h5>Resultados: {{ table.totalRows }}</h5>
        </div>

        <b-col cols="12" class="pr-0 pl-0">
          
          <b-skeleton-wrapper v-if="loadingTable">
            <b-skeleton
              v-for="i in 15"
              :key="i"
              width="100%" 
              height="50px"
            />
          </b-skeleton-wrapper>

          <b-table
            v-if="items.length > 0"
            bordered striped responsive
            :per-page="table.size"
            :items="items"
            :fields="fieldsTable"
          >
            <template #cell(acciones)="data">
              <div class="d-flex justify-content-end">
                <b-button
                  variant="info"
                  size="sm"
                  @click="viewItem(data.item.tokenAuxiliar)"
                >
                  <font-awesome-icon
                    icon="magnifying-glass"
                    style="color: white"
                  />
                </b-button>
                <b-button
                  variant="primary"
                  size="sm"
                  @click="editItem(data.item.tokenAuxiliar)"
                >
                  <font-awesome-icon icon="user-pen" style="color: white" />
                </b-button>
                <b-button
                  variant="danger"
                  size="sm"
                  @click="removeItemid(data.item.idDoctor)"
                >
                  <font-awesome-icon icon="circle-xmark" style="color: white" />
                </b-button>
              </div>
            </template>
          </b-table>

          <div v-else class="text-center">
            <p>No se encontraron registros</p>
          </div>
        </b-col>

        <b-col cols="12" class="mb-2">
          <b-pagination
            v-if="items.length > 0"
            v-model="table.page"
            :total-rows="table.totalRows"
            :small="true"
            first-number
            last-number
            class="mb-0"
            align="center"
            prev-class="prev-item"
            next-class="next-item"
            @change="onChangePage"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </b-col>
      </b-card>
    </b-overlay>

    <VerAuxiliar/>

  </div>
</template>
<script>
import { BootstrapVue } from 'bootstrap-vue';
import actions from "@/assets/utils/utils";
import vSelect from "vue-select";
import axios from "axios";
import  VerAuxiliar   from '@/views/administracion/components/auxiliares/VerAuxiliar.vue';
import { comprobarPermisos, getEstablecimientoLS } from "@/shared/helpers";
import rutas from "@/assets/utils/rutas.json";
import { auxiliarMedicoService } from '../../services';

export default {

  components: {
    ...BootstrapVue.components,
    
    vSelect,
    VerAuxiliar
  },

  data() {
    return {
      filters:{
        search: null,
        tipoAuxiliar:null
      },

      table: {
        page: 1,
        size: 15,
        totalRows: 0,
      },

      loadingTable: false,

      tipoAuxiliarOpts: [],

      mostrarLoader: false,
      login_user: "",

      fieldsTable: [
        {
          key: "nombres",
          label: "Nombres",
          sortable: true,
          thClass: "text-center",
        },
        
        {
          key      : "tipoauxiliar",
          label    : "Tipo Auxiliar",
          sortable : true,
          thClass  : "text-center",
        },
        {
          key      : "activo",
          label    : "Estado",
          sortable : true,
          thClass  : "text-center",
        },
        
        {
          key: "usuario",
          label: "Usuario",
          sortable: true,
          thClass: "text-center",
          width: "150px",
        },

        {
          key: "acciones",
          label: "acciones",
          sortable: true,
          thClass: "text-center",
          tdClass: "text-right",
        },
      ],

      items: [],
      descripcion: "",
    };
  },

  created() {
    comprobarPermisos(this.$route);

    this.loadDataFilters();
    this.loadDataTable();
    this.setToken();
  },

  mounted() {
    actions.setearTitulo("Auxiliar");
  },

  methods: {

    async loadDataFilters() {
      this.tipoAuxiliarOpts = await auxiliarMedicoService.getTipos();
    },

    viewItem(tokenAuxiliar) {
      this.navigateToQuery('view', tokenAuxiliar)
    },



    onRowSelected(items) {
      this.selected = items;
    },


    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },


    onChangePage(value) {
      this.table.page = value;
      this.loadDataTable();
    },


    onSearchAux(){
      this.table.page = 1;
      this.loadDataTable();
    },


    async loadDataTable() {

      this.loadingTable = true;

      const params = {
        // establecimiento : getEstablecimientoLS()?.id,
        search          : this.filters.search,
        tipoAuxiliar    : this.filters.tipoAuxiliar,
        page            : this.table.page,
        pageSize        : this.table.size,
      }

      const searchAuxiliar = await auxiliarMedicoService.getAll(params);

      if(!searchAuxiliar) return;
      const auxiliares = searchAuxiliar?.auxiliares || [];

      this.table.totalRows = searchAuxiliar.total;

      const auxiliarMapped = auxiliares.map((item) => {
        return {
          idDoctor       : item.id,
          tokenAuxiliar  : item.token,
          fechainicio    : item.fechainicio,
          fechafin       : item.fechafin,
          // identificacion : item.idPersona.identificacion,
          nombres        : `${item.idPersona.identificacion} - ${item.idPersona.primerApellido} ${item.idPersona.primerNombre}`,
          tipoauxiliar   : item.tipoauxiliar?.descripcion,
          activo         : item.activo ? "Activo" : "Inactivo",
          usuario        : item.idPersona.detalleusuarioSet?.[0]?.usuario?.username,
        };
      })

      this.items = auxiliarMapped;
      this.loadingTable = false;
    },
    
    editItem(tokenAuxiliar) {
      this.$router.push({
        name: "editar_auxiliar",
        params: { token: tokenAuxiliar },
      });
    },

    removeItemid(idDoc) {
      const mesa = this.fetchRemoveAuxiliar(idDoc);
    },

    async fetchRemoveAuxiliar(idDoc) {
      this.$swal({
        title: "Estas seguro de eliminar auxiliar?",
        text: "No seras capaz de revertir esto!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, Borrar esto!",
        cancelButtonText: "No, cancelar!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          // Call the API or method to remove the item here

          const query = `
            mutation MyMutation($id: String!) {
              eliminarAuxiliarMedico(
                auxiliarMedicoData: {id: $id}
              ) {
                message
                status
              }
            } 
          `;

          const variables = {
            id: idDoc,
          };

          try {
            
            const response = await axios.post(rutas.axios + "api", { query, variables });

            if (response.status === 200) {
              if (response.data.data.eliminarAuxiliarMedico.status === "success") {
                if (response.status === 200) {
                  this.$swal({
                    title: "Borrado!",
                    text: "Tu registro ha sido eliminado",
                    icon: "success",
                    confirmButtonColor: "#3085d6",
                  }).then((result) => {
                    // This will only run when the user presses "OK" on the "Deleted!" modal
                    if (result.isConfirmed) {
                      this.$router.go(0);
                    }
                  });
                }
                this.$router.push({ name: "consultar_auxiliar" }).catch((err) => {
                  if (err.name !== "NavigationDuplicated") {
                    console.error(err);
                  }
                });
              } else {
                this.$swal({
                  title: "Error",
                  text: response.data.data.eliminarAuxiliarMedico.message,
                  icon: "error",
                  confirmButtonColor: "#089599",
                });
              }
            }
          } catch (err) {
            console.log(err);
            return "Error al eliminar auxiliar";
          }
        } else {
          // User clicked the cancel button
          this.$swal({
            title: "Cancelado",
            text: "Your registro esta seguro :)",
            icon: "error",
            confirmButtonColor: "#3085d6",
          });
        }
      });
    },


    setToken() {
      const user = JSON.parse(localStorage.getItem("usuario"));
      this.login_user = user.username;
      axios.defaults.headers.common.Authorization = `JWT ${user.token}`;
    },


    navigateToQuery(queryParam, valueQuery) {
      try {
        this.$router.push({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            [queryParam]: valueQuery,
          },
        });
      } catch (error) {
        console.error("Error en la navegación:", error);
      }
    },
    
  },
  
};
</script>



<style lang="scss">
@import "@/assets/scss/vue/libs/vue-select.scss";
</style>
